export interface GDHState {
  email: string;
  serviceIndex: string;
  serviceData: string;
}

const state: GDHState = {
  email: '',
  serviceIndex: 'lms',
  serviceData: '{}',
};

export default state;
